import React, { useState } from 'react'
import { NavBar } from '../../../components/NavBar/NavBar'
import {
  Flex,
  H1WithBack,
  PageWrapper,
  ContentWrapper,
} from '../../../styling/GlobalStyles'
import { ModelsSpecificationTab } from './ModelsSpecificationTab'
import { useDispatch } from 'react-redux'
import { addMachineModel } from '../../../features/machineModels/machineModelsSlice'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { AppDispatch } from 'store'
import { IMachineModel } from 'types/machineModels.interface'
import { modelSpecificationTabInputs } from './modelValidation'

export const AddModel = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const [invalidFields, setInvalidFields] = useState(modelSpecificationTabInputs)
  // const [invalidCategoryFields, setInvalidCategoryFields] = useState<string[]>([])
  const [state, setState] = useState<IMachineModel>({
    make: '',
    model: '',
    fuelType: null,
    fields: [],
    category: null,
  })


  const handleSubmit = async () => {

    if (invalidFields.length < 1) {

      const resp = await dispatch(addMachineModel(state))
      if (resp.meta.requestStatus === 'fulfilled') {
        navigate('/resources-models')
      }
    } else {
      toast.warn('All fields must be valid')
    }
  }

  return (
    <div>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack mb='1.5' arrow title='Add Machinery model' />

        </Flex>
        <ContentWrapper>
          <ModelsSpecificationTab
            state={state}
            setState={setState}
            handleSubmit={handleSubmit}
            invalidFields={invalidFields}
            setInvalidFields={setInvalidFields}

          />
        </ContentWrapper>
      </PageWrapper>
    </div>
  )
}
